import React from "react";
import PropTypes from "prop-types";

import css from "./FeatureMediaWithCaption.module.scss";
import AnimateOpacity from "components/ParallaxAnimation/AnimateOpacity";
import Sticky from "components/Sticky";

const FeatureMediaWithCaption = ({ text }) => {
    return (
        <AnimateOpacity
            start="self"
            startOffset="25vh"
            duration="25vh"
            className={css.animationWrapper}
        >
            <Sticky type="div" props={{className:css.captionWrapper}} isSticky={true} isAtBottom={true}>
                <p className={css.caption}>{text}</p>
            </Sticky>
        </AnimateOpacity>
    );
};

FeatureMediaWithCaption.propTypes = {
    text: PropTypes.string
};

export default FeatureMediaWithCaption;



// WEBPACK FOOTER //
// ./src/components/FeatureMediaWithCaption/FeatureMediaWithCaption.jsx